<template>
  <div class="forgot-wrapper">
    <h2>Forgot Password</h2>
    <el-form
      :model="form"
      :rules="rules"
      hide-required-asterisk
      label-position="top"
      ref="form"
      label-width="100px"
      class="forgot-form-wrapper"
      @keyup.enter.native="handleSubmit"
    >
      <template v-if="next">
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="Verification Code" prop="captcha">
          <div class="verification-wrapper">
            <el-input v-model="form.captcha" class="verification-input" />
            <img
              :src="imgCaptcha"
              alt="图片验证码"
              class="verification-captcha"
            />
          </div>
        </el-form-item>
        <el-form-item label="E-mail verification code" prop="emailCode">
          <el-input v-model="form.emailCode" @input="_compareCode">
            <a
              href="javascript:;"
              slot="suffix"
              class="send-verification-btn"
              @click="handleEmailCode"
            >
              {{ sendEmailBtnText }}
            </a>
            <template v-if="sure">
              <span
                slot="suffix"
                style="padding-right: 10px; color: green; font-size: 20px"
              >
                ✔
              </span>
            </template>
            <template v-if="wrong">
              <span
                slot="suffix"
                style="padding-right: 10px; color: red; font-size: 20px"
              >
                ×
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <customize-button
            size="large"
            type="primary"
            @click="Tonext"
            :btn-style="{ width: '240px' }"
          >
            Next
          </customize-button>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="New Password" prop="password">
          <el-input v-model="form.password" show-password />
        </el-form-item>
        <el-form-item label="Confirm Password" prop="confirmPassword">
          <el-input v-model="form.confirmPassword" show-password />
        </el-form-item>
        <el-form-item>
          <customize-button
            @click="handleSubmit"
            size="large"
            type="primary"
            :btn-style="{ width: '240px' }"
          >
            Modify Password
          </customize-button>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>
import { getEmailCode, updatePassword, checkCode } from './api'
import { getImgCaptcha } from '@/api'

export default {
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else {
        if (this.form.password !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password again'))
      } else if (value !== this.form.password) {
        callback(new Error('The two passwords are inconsistent!'))
      } else {
        callback()
      }
    }
    return {
      next: true,
      sure: false,
      wrong: false,
      checked: true,
      form: {
        email: '',
        captcha: '',
        emailCode: '',
        password: '',
        confirmPassword: '',
      },
      rules: {
        email: [{ required: true, message: 'Can not be empty!' }],
        captcha: [{ required: true, message: 'Can not be empty!' }],
        emailCode: [{ required: true, message: 'Can not be empty!' }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' },
        ],
      },
      imgCaptcha: '',
      confirmDirty: false,
      sendEmailBtnText: 'Send Email Verification Code',
      btnDisabled: false,
    }
  },
  mounted() {
    this._getImgCaptcha()
  },
  methods: {
    async _compareCode() {
      try {
        const { emailCode, email } = this.form
        const data = await checkCode({ email, emailCode })
        if (data) {
          this.sure = true
          this.wrong = false
        } else {
          this.sure = false
          this.wrong = true
        }
      } catch (error) {
        this.wrong = true
        console.error(error)
      }
      if (this.form.emailCode === '') {
        this.wrong = false
      }
    },
    async Tonext() {
      const { captcha, email, emailCode } = this.form
      if (!captcha || !email || !emailCode) {
        await this.$refs.form.validateField('captcha')
        await this.$refs.form.validateField('email')
        await this.$refs.form.validateField('emailCode')
      } else {
        try {
          const data = await checkCode({ email, emailCode })
          if (data) {
            this.next = false
          } else {
            this.$message.error('EmailCode is error')
          }
        } catch (error) {
          this.form.emailCode = ''
          console.error(error)
        }
      }
    },
    async handleEmailCode() {
      let timer
      let num = 59
      const { captcha, email } = this.form
      if (!captcha || !email) {
        await this.$refs.form.validateField('captcha')
        await this.$refs.form.validateField('email')
      } else {
        try {
          await getEmailCode({
            email,
            captcha,
          })
          clearInterval(timer)
          this.btnDisabled = true
          timer = setInterval(() => {
            this.sendEmailBtnText = `${num}s`
            if (num === 0) {
              clearInterval(timer)
              this.btnDisabled = false
              this.sendEmailBtnText = 'Send Email Verification Code'
              return
            }
            num--
          }, 1000)
          this.$message.success('success')
        } catch (error) {
          console.error(error)
          this.form.captcha = ''
          await this._getImgCaptcha()
        }
      }
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this._updatePassword({ ...this.form })
        }
      })
    },
    async _updatePassword(params) {
      try {
        await updatePassword({ ...params })
        this.$message.success('success')
        await this.$router.push('/user/login')
      } catch (error) {
        console.error(error)
        await this._getImgCaptcha()
      }
    },
    async _getImgCaptcha() {
      const date = Date.now()
      try {
        this.imgCaptcha = await getImgCaptcha(date)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.forgot-wrapper {
  width: 650px;
  margin: 0 auto;

  h2 {
    font-size: 32px;
    color: #3a3f63;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 34px;
  }

  .forgot-form-wrapper {
    :deep(.el-form-item__label) {
      padding-bottom: 0;
      color: #000;
      font-size: 14px;
    }
    :deep(.el-checkbox__inner) {
      background-color: #67c23a;
      border: 1px solid #67c23a;
    }
    :deep(.el-input__inner) {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
    }

    .send-verification-btn {
      font-size: 14px;
      color: #3a3f63;
      line-height: 50px;
      padding-right: 18px;
    }

    .verification-wrapper {
      width: 650px;
      display: flex;
      justify-content: space-between;

      .verification-input {
        width: 420px;
      }

      .verification-captcha {
        width: 130px;
        height: 53px;
        cursor: pointer;
      }
    }
  }
}
</style>
